<nz-affix [nzOffsetTop]="0">
  <hx-breadcrumbs></hx-breadcrumbs>
  <nz-page-header nzBackIcon [nzGhost]="false">
    <nz-page-header-title>{{(isEdit ? 'action.edit' : 'action.create') | transloco}}</nz-page-header-title>
  </nz-page-header>
</nz-affix>


<form class="hx-form" nz-form [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()" *transloco="let tr; prefix: 'faqs'; scope: 'faqs'">
  <div nz-row [nzGutter]="8">
    <div nz-col class="hx-col-1">
      <nz-form-item>
        <nz-form-label nzRequired>{{tr('form.brandId')}}</nz-form-label>
        <nz-form-control>
          <hx-brand-select formControlName="brandId"></hx-brand-select>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <div nz-row [nzGutter]="8">
    <div nz-col class="hx-col-1_2">
      <nz-form-item>
        <nz-form-label nzRequired>{{tr('form.title.ru')}}</nz-form-label>
        <nz-form-control>
          <editor apiKey="1m5chqcqshgnbigriyg35bln3i932yz4xn4obqarh45v1dby" formControlName="titleRu" [init]="{
              language_url:'/assets/i18n/tinymce/ru.js',
              language_load: true,
              language: 'ru',
              plugins: 'lists link image table code help wordcount'}">
          </editor>
          <!--            <hx-label-edit formControlName="title"></hx-label-edit>-->
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col class="hx-col-1_2">
      <nz-form-item>
        <nz-form-label nzRequired>{{tr('form.title.kk')}}</nz-form-label>
        <nz-form-control>
          <editor apiKey="1m5chqcqshgnbigriyg35bln3i932yz4xn4obqarh45v1dby" formControlName="titleKk" [init]="{
              language_url:'/assets/i18n/tinymce/kk.js',
              language_load: true,
              language: 'kk',
              plugins: 'lists link image table code help wordcount'}">
          </editor>

          <!--            <hx-label-edit formControlName="answer"></hx-label-edit>-->
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <div nz-row [nzGutter]="8">
    <div nz-col class="hx-col-1_2">
      <nz-form-item>
        <nz-form-label nzRequired>{{tr('form.answer.ru')}}</nz-form-label>
        <nz-form-control>
          <editor apiKey="1m5chqcqshgnbigriyg35bln3i932yz4xn4obqarh45v1dby" formControlName="answerRu" [init]="{
              language_url:'/assets/i18n/tinymce/ru.js',
              language_load: true,
              language: 'ru',
              plugins: 'lists link image table code help wordcount'}">
          </editor>
          <!--            <hx-label-edit formControlName="title"></hx-label-edit>-->
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col class="hx-col-1_2">
      <nz-form-item>
        <nz-form-label nzRequired>{{tr('form.answer.kk')}}</nz-form-label>
        <nz-form-control>
          <editor apiKey="1m5chqcqshgnbigriyg35bln3i932yz4xn4obqarh45v1dby" formControlName="answerKk" [init]="{
              language_url:'/assets/i18n/tinymce/kk.js',
              language_load: true,
              language: 'kk',
              plugins: 'lists link image table code help wordcount'}">
          </editor>

          <!--            <hx-label-edit formControlName="answer"></hx-label-edit>-->
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <div nz-row [nzGutter]="8">
    <div nz-col class="hx-col-4">
      <nz-form-item>
        <nz-form-label nzRequired>{{tr('form.tags')}}</nz-form-label>
        <nz-form-control>
          <hx-tag-select hxTagContainer="Faqs" formControlName="tags"></hx-tag-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col class="hx-col-4">
      <nz-form-item>
        <nz-form-label nzRequired>{{tr('form.seq')}}</nz-form-label>
        <nz-form-control>
          <nz-input-number formControlName="seq" [nzStep]="1">></nz-input-number>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <div nz-row [nzGutter]="8">
    <div nz-col class="hx-col-4">
      <nz-form-item>
        <nz-form-label nzRequired>{{tr('form.component')}}</nz-form-label>
        <nz-form-control>
          <hx-enum-select enumName="ComponentType" [enumType]="ComponentType" formControlName="component"></hx-enum-select>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco" nzShowIcon></nz-alert>

  <div nz-row [nzGutter]="8" class="cp_actions">
    <div nz-col>
      <nz-form-item>
        <nz-form-control>
          <button [nzLoading]="isSaving" [disabled]="form.pristine || form.pending" type="submit" nz-button nzType="primary">
            <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col>
      <nz-tag nzColor="success" *ngIf="form.pristine && model?.id">
        <i nz-icon nzType="check-circle"></i>
        <span>{{'form.saved' | transloco}}</span>
      </nz-tag>
    </div>
  </div>
</form>

